import { initFederation } from '@angular-architects/native-federation';
import * as leaflet from 'leaflet';

import { environment } from './environments/environment';

(window as { L?: typeof leaflet }).L = leaflet;
const mfSettings = JSON.parse(localStorage.getItem('mf') || '{}');
const isDev =
  !environment.production && environment.environment === 'development';

const getHost = (app: string) =>
  isDev
    ? mfSettings[app] || environment.apps[app].host
    : environment.apps[app].host;

// Build manifest dynamically based on environment apps configuration
const manifest: Record<string, string> = {};
Object.keys(environment.apps)
  .filter((x) => x !== 'isa')
  .forEach((name) => {
    const host = getHost(name);
    if (host) manifest[name] = `${host}/remoteEntry.json`;
  });

initFederation(manifest)
  .then(() => import('./bootstrap'))
  // eslint-disable-next-line no-console
  .catch((err) => console.error(err));
